const Section = ({ n, title, children }) => (
  <section className="mt-6" data-testid={`cgu-section-${n}`}>
    <h2 className="font-heading text-lg md:text-xl font-bold text-slate-900">{n}. {title}</h2>
    <div className="mt-2 text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function CGU() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid="cgu-page">
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">Conditions Générales d'Utilisation</h1>
      <p className="mt-2 text-sm text-slate-500">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <Section n="1" title="Objet">
        <p>Les présentes Conditions Générales d'Utilisation (CGU) définissent les modalités d'accès et d'utilisation de la plateforme PROXIreduc-28 par ses utilisateurs (particuliers, professionnels, organismes).</p>
      </Section>
      <Section n="2" title="Accès au service">
        <p>La consultation des bons plans publics est libre et gratuite. La création d'un compte permet d'accéder au Pass numérique, aux favoris et, selon le profil, à des offres réservées (CSE, associations, clubs).</p>
      </Section>
      <Section n="3" title="Compte et Pass numérique">
        <p>L'utilisateur s'engage à fournir des informations exactes. Chaque membre dispose d'un Pass numérique personnel et unique permettant de bénéficier des offres auprès des partenaires. Le Pass est strictement personnel.</p>
      </Section>
      <Section n="4" title="Utilisation des offres">
        <p>Les offres sont proposées par les partenaires sous leur responsabilité. Les conditions, durées de validité et éventuelles limites d'utilisation sont indiquées sur chaque offre. PROXIreduc-28 n'est pas partie au contrat conclu entre l'utilisateur et le partenaire.</p>
      </Section>
      <Section n="5" title="Comportement des utilisateurs">
        <p>Il est interdit d'utiliser frauduleusement un Pass, de publier des contenus illicites, ou de porter atteinte au bon fonctionnement de la plateforme.</p>
      </Section>
      <Section n="6" title="Signalement">
        <p>Tout utilisateur peut signaler une offre problématique depuis la page de l'offre. PROXIreduc-28 se réserve le droit de suspendre une offre signalée.</p>
      </Section>
      <Section n="7" title="Propriété intellectuelle">
        <p>La marque, le logo et les contenus propres à PROXIreduc-28 sont protégés. Les contenus des partenaires restent leur propriété.</p>
      </Section>
      <Section n="8" title="Données personnelles">
        <p>Les traitements de données sont décrits dans la <a href="/confidentialite" className="text-[#E05638] underline">politique de confidentialité</a>. L'utilisateur peut exercer ses droits (accès, rectification, suppression) depuis son compte.</p>
      </Section>
      <Section n="9" title="Responsabilité">
        <p>PROXIreduc-28 met tout en œuvre pour assurer la disponibilité du service sans pouvoir la garantir en continu. Sa responsabilité ne saurait être engagée en cas d'indisponibilité temporaire.</p>
      </Section>
      <Section n="10" title="Évolution des CGU">
        <p>PROXIreduc-28 peut modifier les présentes CGU. Les utilisateurs sont invités à les consulter régulièrement.</p>
      </Section>
    </div>
  );
}
